import { useQueryClient } from "@tanstack/react-query";
import { uploadOwnerId } from "../../api/owner-ids";
import { useDomainMutation } from "@/modules/common/hooks/domain-mutation.hook";

const useUploadOwnerId = (customerUid?: string) => {
  const queryClient = useQueryClient();

  const mutationUploadOwnerId = useDomainMutation<
    any,
    { response?: { data?: { message?: string } } },
    { formData: FormData }
  >(({ formData }) => uploadOwnerId(formData), {
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["owner-ids", customerUid] });
    },
  });

  return mutationUploadOwnerId;
};

export default useUploadOwnerId;
